/**
 * Sort a list of maps based on a single key.
 */
export default (set, key) => set.sort((mapA, mapB) => {
  if (mapA[key] > mapB[key]) {
    return 1;
  }
  if (mapA[key] < mapB[key]) {
    return -1;
  }
  return 0;
});
